export default __webpack_public_path__ + "static/media/safari200x200.0b8ca1b7.png";